export default [
    {
        key: '11',
        type: 'archive',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '13',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '12',
        type: 'archive',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '20',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '13',
        type: 'archive',
        photo: '',
        excluded: true,
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '23',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '14',
        type: 'archive',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '31',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '15',
        type: 'archive',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '43',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '16',
        type: 'archive',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '65',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '17',
        type: 'archive',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '52',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '18',
        type: 'archive',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '11',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '19',
        type: 'archive',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '19',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '20',
        type: 'archive',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '17',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    }
]